module.exports = __webpack_public_path__ + "img/gva.7922b1de.svg";